module.exports = __webpack_public_path__ + "img/reliable@2x (1).35a033d0.png";